<!-- =========================================================================================
    File Name: CityAddNew.vue
    Description: Add City
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">

        <h4> {{ $t("AllLedgersCreateDescription") }} </h4> <br/>

        <div class="p-6">
            
            <form @submit.prevent="submitForm">

                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span> {{ $t("State") }} </span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <!-- <vs-input class="w-full" v-model="StateId" v-validate="'required'" name="StateId" /> -->
                        <v-select v-model="StateId" name="StateId" :value="StateId" :options="StateIdOptions" label="text" :reduce="option => option.value" v-validate="'required'" v-on:input="getDistrictOptions()" > </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('StateId')">{{ errors.first('StateId') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span> {{ $t("District") }} </span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <!-- <vs-input class="w-full" v-model="DistrictId" v-validate="'required'" name="DistrictId" /> -->
                        <v-select v-model="DistrictId" name="DistrictId" :value="DistrictId" :options="DistrictIdOptions" label="text" :reduce="option => option.value" v-validate="'required'" ></v-select>
                        <span class="text-danger text-sm" v-show="errors.has('DistrictId')"> {{ errors.first('DistrictId') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span> {{ $t("City") }} </span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <vs-input class="w-full" v-model="CityName" v-validate="'required'" name="CityName" />
                        <span class="text-danger text-sm" v-show="errors.has('CityName')">{{ errors.first('CityName') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full text-right mb-3">
                        <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                    </div>
                </div>

            </form>
        </div>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import vSelect from 'vue-select'

export default {
    mixins: [common],
    props: {
        addRecordPrompt: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        'v-select': vSelect,
    },
    data() {
        return {
            // activePrompt: false,
            StateIdOptions: [],
            DistrictIdOptions: [],
            StateId : '',
            DistrictId : '',
            CityName : '',

            recordObj: {},
            record: {},
        }
    },
    computed: {
        dataArrayLength() {
            return this.$store.getters['city/dataArrayLength'];
        },
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideAddRecordPrompt');
        },        
        addRecordDetails() {
            // add todo in store and clear all fields in dialog

            this.recordObj.StateId =  this.StateId;
            this.recordObj.DistrictId =  this.DistrictId;
            this.recordObj.CityName =  this.CityName;

            var server_url=companyConfig.apiURL;
            this.record.token=this.$session.get('token');
            this.record.add_url=server_url+'lib/api/others/city/create';
            this.record.form=this.recordObj;
            this.record.list_url=server_url+'lib/api/others/city/lists';
            this.record.list_where={};
            console.log('record='+JSON.stringify(this.record));
            this.record.loading=this.$vs.loading;
            this.record.notify=this.$vs.notify;
            this.record.http=this.$http;
            this.$store.dispatch('city/addRecordDetails', this.record);

            this.closePrompt();
        },
        clearFields() {
            // clear all fileds in todo
            this.StateId =  '';
            this.DistrictId =  '';
            this.CityName =  '';

            this.$parent.addRecordPrompt = false;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.addRecordDetails();
            })
        },
        getDistrictOptions(){
            console.log('getDistrictOptions is called');
            console.log('StateIdOptions='+JSON.stringify(this.StateIdOptions));
            var tempStateId=this.StateId;
            console.log('tempStateId='+tempStateId);
            if (tempStateId != "") {
                var selectbox2_source = 'DistrictId'
                var selectbox2_destination = 'DistrictIdOptions'
                var selectbox2_url = 'lib/api/data/get_district_options'
                var selectbox2_conditions_array = {
                    'district_details_state_details_id': tempStateId
                }
                this.getSelectBoxOptions(selectbox2_source, selectbox2_destination, selectbox2_conditions_array, selectbox2_url)
            }
            
        }
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            const token=this.$session.get('token');
            console.log('token='+token);
            
            var selectbox1_source = 'StateId'
            var selectbox1_destination = 'StateIdOptions'
            var selectbox1_url = 'lib/api/data/get_states_options'
            var selectbox1_conditions_array = {
                'state_details_id > ': 0
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url)
            
        }
    },
    watch: {
        
        StateIdOptions: function(){            
            console.log('watch StateIdOptions='+JSON.stringify(this.StateIdOptions));
            var n1=this.StateIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.StateIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.StateId;
                var str2=str1.toString();
                console.log('str1='+str1+', str2='+str2);                
                this.StateId=str2 != "" ? str2 : temp;
            }
        },
        /*
        DistrictIdOptions: function(){
            console.log('watch DistrictIdOptions='+JSON.stringify(this.DistrictIdOptions));
            var n1=this.DistrictIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.DistrictIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.DistrictId;
                var str2=str1.toString();
                console.log('str1='+str1+', str2='+str2);                
                this.DistrictId=str2 != "" ? str2 : temp;
            }
        },
        */
    },
}
</script>
<style>
.con-vs-dialog .vs-dialog{
    max-width: 600px;
}
</style>